module.exports = __webpack_public_path__ + "media/images/badges/kinrgy/Kinrgy-250-Classes-Active-adf562b35abbf5d6dea84bdd41cafacd.png";